import CONFIG from '../../public/config.json';
import { VersionInfo, PromiseFulfilledResult } from './types';

class Config {
  #config: (typeof CONFIG & { versionInfo: VersionInfo }) | null;

  constructor() {
    this.#config = null;
  }

  async fetchConfig() {
    const [config, versionInfo] = (await Promise.allSettled([
      fetch(`${window.location.origin}/config.json`).then(res => res.json()),
      fetch(`${window.location.origin}/versionInfo.json`).then(res => res.json()),
    ])) as [PromiseFulfilledResult<typeof CONFIG>, PromiseFulfilledResult<VersionInfo>];
    this.#config = {
      ...config.value,
      versionInfo: versionInfo.value,
    };
  }

  get value() {
    return this.#config;
  }
}

export const config = new Config();
